import React, { useEffect, useRef } from 'react';
import { REACT_APP_AUTHORIZENET_ACCEPT_URL } from '../config';
import '../styles/FormAuthorizeNet.css';

interface FormAuthorizeNetProps {
  formToken: string;
  onClose?: () => void;
}

const IFRAME_NAME = 'authorizeNetIframe';

function FormAuthorizeNet({ formToken, onClose }: FormAuthorizeNetProps) {
  const formRef = useRef<HTMLFormElement>(null);

  useEffect(() => {
    if (formToken && formRef.current) {
      formRef.current.submit();
    }
  }, [formToken]);

  if (!formToken) {
    return null;
  }

  return (
    <div className="authnet-overlay">
      <div className="authnet-modal">
        {onClose && (
          <button type="button" className="authnet-close" onClick={onClose} aria-label="close">
            ×
          </button>
        )}
        <iframe title="Authorize.Net" name={IFRAME_NAME} className="authnet-iframe" />
        <form ref={formRef} method="POST" action={REACT_APP_AUTHORIZENET_ACCEPT_URL} target={IFRAME_NAME} className="authnet-form">
          <input type="hidden" name="token" value={formToken} />
        </form>
      </div>
    </div>
  );
}

export default FormAuthorizeNet;
